import { cva } from 'class-variance-authority';

/**
 * The stat card's surface.
 *
 * One surface for every tone: the tone changes the VALUE's ink and nothing else. A card whose
 * background changes colour reads as a different KIND of card, and an operator starts sorting by
 * colour instead of by label.
 */
export const statCardStyles = cva(
  [
    'flex flex-col gap-1 rounded-control border border-border bg-surface px-4 py-3',
    'transition-colors',
  ],
  {
    variants: {
      interactive: {
        true: 'hover:border-border-strong hover:bg-surface-raised focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent',
        false: '',
      },
    },
    defaultVariants: {
      interactive: false,
    },
  },
);

/** The label above the value. */
export const statCardLabelStyles = 'text-xs font-medium uppercase tracking-wide text-content-muted';

/** The number. */
export const statCardValueStyles = 'text-2xl font-semibold leading-tight';

/** The optional context under the number. */
export const statCardCaptionStyles = 'text-xs text-content-muted';

/** The tone's ink, applied to the VALUE only. */
export const statCardToneStyles: Readonly<Record<string, string>> = {
  neutral: 'text-content',
  positive: 'text-positive',
  warning: 'text-caution',
  critical: 'text-critical',
};
